import { FormData } from 'src/pages/ServiceMaintenance/types'
import { ServiceType } from 'src/pages/ServiceMaintenance/enums'

export const DEFAULT_VALUES: FormData = {
  date: new Date(),
  serviceType: ServiceType.OIL_CHANGE,
  address: '',
  odometer: '',
  details: '',
  serviceCost: '',
}
